export interface Approvable<T> {
  // private String approvedBy;
  // private Date approvedOn;
  // private String responseMessage;
  // private String currentStatus;
  // private User submittedFor;
  // private User submittedBy;
  //
  // private String name;
  // private Long txnTypeId;
  // private DocFile docFile;
  // private boolean editable;
  // private Date submittedOn;
  //
  // // For serialization
  // private Long submittedById;
  // private Long submittedForId;
  // private Long docFileId;

  approvedBy?: string;
  approvedOn?: Date;
  responseMessage?: string;
  currentStatus?: string;

  submittedById?: number;
  submittedForId?: number;
}
